export default __webpack_public_path__ + "static/media/nfl-live.6e26adcf.jpg";